import { LoginForm } from '../features/auth/components/LoginForm';
import { Footer } from '../components/Footer';

// Asegurarse de que se exporta
export const LoginPage = () => {
  return (
    <div className='min-h-screen flex flex-col bg-background'>
      <div className='flex flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        {/* Podríamos añadir un logo aquí */}
        <h2 className='mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-foreground'>
            QMS
        </h2>
      </div>

      <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-card text-card-foreground px-6 py-8 shadow-sm rounded-lg border'>
        <LoginForm />
      </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};
